// Vite + Rails entry point
console.log('Vite ⚡️ Rails')

// Import Tailwind CSS
import './application.css'

// Import Hotwire Turbo
import * as Turbo from '@hotwired/turbo'
Turbo.start()

// Import Lucide icons
import { createIcons, icons } from 'lucide'

// Import Tippy.js for tooltips
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

// Initialize Lucide icons on page load and after Turbo navigations
const initLucide = () => createIcons({ icons })

// Initialize Tippy tooltips
const initTippy = () => {
  tippy('[data-tippy-content]', {
    theme: 'light',
    placement: 'bottom',
    arrow: true,
    maxWidth: 300,
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initLucide()
  initTippy()
})
document.addEventListener('turbo:load', () => {
  initLucide()
  initTippy()
})
document.addEventListener('turbo:frame-load', () => {
  initLucide()
  initTippy()
})

// Import Stimulus
import { Application } from '@hotwired/stimulus'

// Start Stimulus
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import all Stimulus controllers
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })
Object.entries(controllers).forEach(([path, module]) => {
  const name = path.match(/controllers\/(.+)_controller\.js$/)[1].replace(/_/g, '-').replace(/\//g, '--')
  application.register(name, module.default)
})

export { application }
